import { UploadDragger as AntdUploadDragger } from "@empglabs/backoffice-ui-kit"

const UploadDragger = props => {
  return <AntdUploadDragger {...props} />
}

export default UploadDragger
